import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgStepFinal = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    ref={svgRef}
    {...props}
  >
    <circle cx={16} cy={16} r={15} stroke="#DFE1E6" strokeWidth={2} />
    <path
      fill="#696C71"
      fillRule="evenodd"
      d="M10.125 12.3v8.18h11.75v-8.181l-5.874-3.264-5.876 3.264zm-1.153-1.791c-.6.333-.972.965-.972 1.651v8.555a1.89 1.89 0 001.889 1.89H22.11A1.889 1.889 0 0024 20.714V12.16a1.89 1.89 0 00-.971-1.651l-6.11-3.395a1.889 1.889 0 00-1.835 0l-6.112 3.395z"
      clipRule="evenodd"
    />
    <path
      fill="#696C71"
      fillRule="evenodd"
      d="M8.855 12.3c.291-.51.94-.687 1.45-.396L16 15.158l5.695-3.254a1.062 1.062 0 011.054 1.845l-6.222 3.556a1.063 1.063 0 01-1.054 0L9.25 13.749a1.062 1.062 0 01-.396-1.45z"
      clipRule="evenodd"
    />
  </svg>
));
SvgStepFinal.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgStepFinal;
